import PageShell from "@/components/PageShell";
import {
  Plane, Landmark, Briefcase, GraduationCap, HardHat, Mountain, TrendingUp,
  Users, Building2, Shield, Palmtree, Globe, Fuel,
} from "lucide-react";
import { SECTORS } from "@/lib/content";
import { Link } from "react-router-dom";

const ICONS = {
  Plane, Landmark, Briefcase, GraduationCap, HardHat, Mountain, TrendingUp,
  Users, Building2, Shield, Palmtree, Globe, Fuel,
};

export default function Sectors() {
  return (
    <PageShell
      testId="sectors-page"
      title="Sectors We Serve — Salihi Group"
      description="Salihi Group supports organisations across aviation, banking, professional services, education, construction, mining, investment, workforce services, government, security, travel, and international development."
      eyebrow="Sectors"
      heading={<>Sectors we <em className="text-gold not-italic">serve</em>.</>}
      subheading="Thirteen sectors — one integrated professional services platform."
      breadcrumbs={[{ label: "Sectors" }]}
    >
      <div className="max-w-3xl mb-16">
        <p className="text-navy text-[17px] leading-[1.75] font-light">
          Salihi Group is set up to support organisations across a wide range of sectors — with legal, consulting,
          engineering, investment, mining, and workforce services delivered through a single coordinated platform.
          Where a matter spans several disciplines, we bring together the right subsidiaries so that clients receive
          one coherent response.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {SECTORS.map((sector, i) => {
          const Icon = ICONS[sector.icon] || Briefcase;
          return (
            <article
              key={sector.name}
              data-testid={`sector-card-${i}`}
              className="group bg-white border border-softgray p-7 hover:border-gold hover:shadow-[0_18px_50px_-25px_rgba(15,42,92,0.15)] transition-all"
            >
              <div className="flex items-baseline gap-3 mb-5">
                <Icon size={24} strokeWidth={1.5} className="text-gold" />
                <span className="font-mono text-gold text-xs tabular-nums ml-auto">
                  {(i + 1).toString().padStart(2, "0")}
                </span>
              </div>
              <h3 className="font-serif text-navy text-xl leading-tight mb-3">{sector.name}</h3>
              <p className="text-mutedink text-[14px] leading-relaxed font-light">{sector.description}</p>
            </article>
          );
        })}
      </div>

      {/* CTA band */}
      <div className="mt-20 pt-14 border-t border-softgray text-center max-w-3xl mx-auto">
        <h3 className="font-serif text-navy text-2xl md:text-3xl font-light mb-4">
          Working in a sector not listed?
        </h3>
        <p className="text-mutedink mb-6">
          We are happy to discuss whether Salihi Group can support your organisation. Every sector benefits from
          the underlying professional disciplines we deliver — legal, consulting, engineering, investment, mining,
          Oil & Gas, and workforce services.
        </p>
        <Link to="/contact" className="btn-gold" data-testid="sectors-cta-contact">Get in touch</Link>
      </div>
    </PageShell>
  );
}
